import { render } from "./InscriptionCourses.vue?vue&type=template&id=b9ea20ae&scoped=true"
import script from "./InscriptionCourses.vue?vue&type=script&lang=js"
export * from "./InscriptionCourses.vue?vue&type=script&lang=js"

import "./InscriptionCourses.vue?vue&type=style&index=0&id=b9ea20ae&scoped=true&lang=css"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9ea20ae"]])

export default __exports__